const createBrowserHistory = require('history').createBrowserHistory;


export const history = createBrowserHistory();